'use client';

import {
  AccordionContent,
  AccordionDefaultLayout,
  AccordionItem,
  AccordionTrigger,
  IcArrowDown,
  IconButton,
  Padding,
  Typography,
} from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';

type FaqAccordionProps = {
  title: string;
  description: string;
  className?: string;
};

export const FaqAccordion = ({ title, description, className }: FaqAccordionProps) => (
  <AccordionItem value={title} className={twMerge('bg-white', className)}>
    <AccordionTrigger
      iconButton={
        <IconButton asChild size="size16x16">
          <IcArrowDown strokeColor="gray-500" />
        </IconButton>
      }
    >
      <Typography variant="body14pxMed">{title}</Typography>
    </AccordionTrigger>
    <AccordionContent>
      <AccordionDefaultLayout className="bg-gray-100">
        <Padding top="2" bottom="2" className="leading-[18px]">
          <Typography variant="body13pxReg" className="!leading-[18px]">
            {description}
          </Typography>
        </Padding>
      </AccordionDefaultLayout>
    </AccordionContent>
  </AccordionItem>
);
